

import React from 'react'
import Breadcrumbs from './breadcrumb.jsx'
import { string, object } from 'prop-types'

class Breadcrumb extends React.Component {
  render () {
    const { id, pageData, setVar } = this.props
    const { breadcrumb = false } = setVar

    if (!breadcrumb) return null
    return (
      <figure id={id}>
        <nav role='navigation'>
          <Breadcrumbs breadcrumb={breadcrumb} pageName={pageData.pageName} />
        </nav>
      </figure>
    )
  }
}

Breadcrumb.propTypes = {
  id: string.isRequired,
  pageData: object,
  setVar: object
}

export default Breadcrumb



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/breadcrumb-include.jsx